import { FieldCellMixins } from './mixins.js';
import { newAlertify } from 'trunks/vue/admin/components/alert.js';
import Popover from 'trunks/vue/admin/components/libs/popover.js';

const UserItemCell = {
  mixins: [FieldCellMixins],

  components: {
    'Popover': Popover
  },

  template: `
    <div class="justify-box" v-if="hasValue">
      <headimg :src="entry.value.headimgurl" extendClass='user-item-headimg'></headimg>
      <div class="darken-text ml-2 text-ellipsis">
        <div class="details-name">
          <span>{{ entry.value.name }}</span>
          <Popover position='bottom center' :customClass='"confirm table-operation-confirm-popover"' ref="confirmPopoverRef">
            <template slot='trigger'>
              <i class="slp-phone" v-if="entry.value.openid" @click.stop="togglePopover"></i>
            </template>
            <template slot='content'>
              <div class="popover-confirm-content">
                <div class="popover-confirm-title">确认取消绑定</div>
                <div class="popover-confirm-footer">
                  <span class="btn btn-small btn-default outlined" @click.stop="cancel">取消</span>
                  <span class="btn btn-small btn-danger" @click.stop="unbindUserFunc(entry.value.id)">确定</span>
                </div>
              </div>
            </template>
          </Popover>
        </div>
        <span class="text-small light-gray-text">{{ entry.value.identifier }}</span>
      </div>
    </div>
  `,

  methods: {
    unbindUserFunc: function(id) {
      Skylark.Libs.Ajax.delete(`/admin/users/${id}/unbind`, {
        contentType: 'application/json; charset=utf-8',
        success: () => {
          newAlertify('解绑成功', {
            type: 'success'
          });

          this.cancel();
          this.$emit('unbindUser', id);
        },
        error: function() {
          newAlertify('解绑失败', {
            type: 'error'
          });
        }
      });
    },

    cancel: function() {
      this.$refs.confirmPopoverRef.close();
    },

    togglePopover: function() {
      this.$refs.confirmPopoverRef.togglePopover();
    }
  }
};

export { UserItemCell };
